import React, { forwardRef } from "react";
import { BSHeading } from "../../types";

export const ModalTitle = forwardRef<HTMLHeadingElement, BSHeading>(
  ({ className = "", children, component: Component = "h5", ...props }, ref) => (
    <Component {...props} className={`modal-title ${className}`} ref={ref}>
      {children}
    </Component>
  )
);